import React from 'react'
import { connect } from 'react-redux'
import toJS from '../../../containers/general/toJS.js';
import DatePicker, { registerLocale } from "react-datepicker";
// import de from 'date-fns/locale/de';
// import en from 'date-fns/locale/en-GB';
import getNewSpellingForDates from '../../../functions/getNewSpellingForDates';
import Translation from '../../Translation/cont/Translation';

// registerLocale('de', de);


const mapStateToProps = state => ({
    translationChooseDate: state.getIn(['translation', 'strings', 'formik_datepicker_choose_date']),
    currentLang: state.getIn(['translation', 'currentLang']),
})

const DatePickerContainer =  ({
    name, 
    onChange,
    value,
    id,
    resetValue='',
    isStartDate=false,
    label,
    className,
    start=false,
    end=false,
    translationChooseDate,
    currentLang
}) => {
    const today = new Date()
    const minDate = start ? new Date(start) : today
  
    

    return (
        <DatePicker
            selected={(value !== '' && new Date(value)) || null}
            onChange={val => {
                if(isStartDate && val > new Date(end)) {                
                    onChange(name, val);
                    onChange(resetValue, '');
                } else if(val === null) {
                    onChange(name, '');
                } else {
                    onChange(name, val);
                }
            }}
            dateFormat="dd/MM/yyyy"
            locale={currentLang}
            todayButton={<Translation id="formik_datepicker_today"/>}
            isClearable
            showWeekNumbers
            minDate={minDate}
            placeholderText={translationChooseDate[currentLang]}
        />
    )
}

export default connect(mapStateToProps)(toJS(DatePickerContainer))